import { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getAllByClanakId } from "../../services/statistikaClanka.service";
import { format, parseISO } from "date-fns";
import "./PosjecenostClankaOdNastankaChart.css";

const PosjecenostClankaOdNastankaChart = ({ clanakId }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!clanakId) return;

    const fetchData = async () => {
      try {
        const { data: posjete } = await getAllByClanakId(clanakId);

        const posjetePoDanu = {};
        posjete.forEach((posjeta) => {
          const rawDate = posjeta.vremenskaOznaka || posjeta.vremenska_oznaka;
          if (!rawDate) return;

          const visitDate = format(parseISO(rawDate), "dd. MM. yyyy.");
          posjetePoDanu[visitDate] = (posjetePoDanu[visitDate] || 0) + 1;
        });

        const formattedData = Object.keys(posjetePoDanu).map((date) => ({
          date,
          posjete: posjetePoDanu[date],
        }));

        setData(formattedData);
      } catch (error) {
      }
    };

    fetchData();
  }, [clanakId]);

  return (
    <div className="posjecenost-odnastanka">
      <h2 className="posjecenost-odnastanka-h2">Ukupna posjećenost članka</h2>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 30, right: 30, left: 20, bottom: 60 }}
        >
          <XAxis
            dataKey="date"
            angle={-30}
            textAnchor="end"
            height={60}
            interval={Math.ceil(data.length / data.length) * data.length - 2}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="posjete"
            stroke="#2e5e32"
            name="Broj posjeta"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PosjecenostClankaOdNastankaChart;
